/*
 * Адаптер для преобразования потомков УДК к научным направлениям.
 */
export default function ScientificScopesAdapter() {
  /**
   * Преобразует модель данных для УДК в научное направление.
   * @param model Модель из ответа api, либо Udc, либо UdcDescendant.
   */
  const convertOne = (model) => ({
    id: model.id,
    notation: model.notation,
    caption: model.caption,
  });

  const convertMany = (models) => {
    return models.map((el) => convertOne(el));
  };

  return {
    convertOne,
    convertMany,
  };
}
